/* eslint-disable react-hooks/exhaustive-deps */
import getUrl from '@utils/api-helper/getUrl';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useGroupsChangeStore from '@stores/groups/groupsChangeStore';
import fetcher from '@api/fetchers';

const joinInvite = async ({ groupUID, goalUID, inviteeUID, inviteLinkUID }) => {
  try {
    const requestUrl = getUrl({
      endpoint: 'v1/group/join/',
      nextPreviewMode: false
    });
    return fetcher(requestUrl, {
      requestType: 'POST',
      body: {
        goal_uid: goalUID,
        group_uid: groupUID,
        invite_link_uid: inviteLinkUID,
        invitee_uid: inviteeUID
      }
    }).then((res) => ({
      data: res
    }));
  } catch (e) {
    return {
      data: null,
      error: e
    };
  }
};

const useGroupJoinInvite = (shouldJoinGroupViaInvite) => {
  const router = useRouter();
  const { query = {} } = router;
  const { groupUID, inviteLinkUID, inviteeUID, goalUID } = query;
  const { toggleIsGroupNew } = useGroupsChangeStore();

  const [error, setError] = useState(null);

  useEffect(() => {
    if (shouldJoinGroupViaInvite) {
      (async () => {
        const { data = {} } = await joinInvite({
          groupUID,
          inviteLinkUID,
          inviteeUID,
          goalUID
        });

        if (!!data && !data.error) {
          toggleIsGroupNew(true);
        } else {
          const results = await data.error;
          const { error_code, error_title, error_description, message } =
            results || {};
          if (error_code || error_title || error_description) {
            setError({
              message,
              title: error_title,
              description: error_description || message
            });
          }
        }
      })();
    }
  }, [shouldJoinGroupViaInvite]);

  return {
    groupJoinError: error
  };
};

export default useGroupJoinInvite;
